
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-management-software",
      function () {
        return require("private-next-pages/partner-management-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-management-software"])
      });
    }
  